
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-delivery",
      function () {
        return require("private-next-pages/service-delivery.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service-delivery"])
      });
    }
  